import React from 'react'

import { Cell } from 'elements/layout/Cell'
import { Row } from 'elements/layout/Row'
import { ScrollDiv } from 'elements/layout/ScrollDiv'

import { CommunityBlock, TCommunityBlockProps } from './CommunityBlock'

export type TCommunitiesPropositionsProps = {
  communities?: number[]
} & Pick<TCommunityBlockProps, 'onClick' | 'onJoin' | 'trackingSource' | 'eventOrigin'>

export const CommunitiesPropositions: TFC<TCommunitiesPropositionsProps> = ({
  communities,
  onClick,
  onJoin,
  trackingSource,
  eventOrigin,
}) =>
  communities && communities.length !== 0 ? (
    <ScrollDiv overflowX="auto" overflowY="hidden" p="5px" scrollbarWidth="10px">
      <Row gutter="1em" nowrap noPrint w={{ xs: 'min-content', md: '100%' }}>
        {communities.map((communityId) => (
          <Cell key={communityId} w={{ xs: '270px', md: 1 / 3 }}>
            <CommunityBlock
              hasFixedHeight
              communityId={communityId}
              onClick={onClick}
              onJoin={onJoin}
              shadow
              trackingSource={trackingSource}
              eventOrigin={eventOrigin}
            />
          </Cell>
        ))}
      </Row>
    </ScrollDiv>
  ) : null
